// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__6WSg5","clinicsSelect":"TableHeading_clinicsSelect__2L9-9"};